import { stringToHash } from 'utils/helpers'
import { BannerPosterBackgroundCoverSC } from './Banner.styled'

export const useBannerBackroundCover = (
  title: string,
  covers?: Record<string, any>
) => {
  if (!covers) return

  const getPoster = (title: string, listLength: number): `Cover${number}` => {
    const subCategoryNameHash = stringToHash(title)
    const itemNumber = Math.abs(subCategoryNameHash) % listLength
    const item =
      itemNumber > 0
        ? itemNumber <= listLength + 1
          ? itemNumber
          : listLength + 1
        : 1
    return `Cover${item}`
  }
  const img = getPoster(title, Object.keys(covers).length)

  return (
    <BannerPosterBackgroundCoverSC>
      <img src={covers[img]} />
    </BannerPosterBackgroundCoverSC>
  )
}
